import { useBrandsSearchQuery } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/__internal__/useBrandsSearchQuery";

export const useLoggedOutSuppliersPagePageCount = (): number | undefined => {
  return useBrandsSearchQuery().data?.pageCount;
};
